import React from "react"
import {
  Box,
  List,
  Typography,
  Button,
  Switch,
  FormControlLabel,
} from "@material-ui/core"

import TicketListItem from "./TicketListItem"
import Flex from "../../lib/components/Flex"
import { TicketAssignee } from "../../constants/enums"
import useTicketColumn from "../../hooks/useTicketColumn"


export default function TrackingColumn (
  { assignedGroup, tagFilters = [] }:
  {
    assignedGroup: string
    tagFilters: string[]
  },
) {
  // TODO: Don't load claim for each ticket.
  //   Tickets should already have a type field, or better:
  //   Tickets should be merged with claims,
  //   since each claim has exactly one ticket.
  const {
    ticketDocs,
    hasMore,
    loadingMore,
    loadMore,
    shouldLoadAll,
    setShouldLoadAll,
  } = useTicketColumn({
    assignedGroup,
    claimType: "diesel",
    tagFilters,
  })

  return (
    <Box p={0.5}>
      <Typography variant='h6' color='textPrimary' gutterBottom align='center'>
        {assignedGroup}
      </Typography>
      <Flex center>
        <FormControlLabel
          control={
            <Switch
              checked={shouldLoadAll}
              onChange={() => setShouldLoadAll(!shouldLoadAll)}
            />
          }
          label='Load All'
          // @ts-expect-error TODO: variant does not exist?
          variant='filled'
          labelPlacement='start'
        />
      </Flex>
      <List dense>
        {ticketDocs.map(ticketDoc => {
          const { claimId } = ticketDoc.data()
          const link = assignedGroup === TicketAssignee.DATA_ENTRY
            ? `/claims/${claimId}/show/6`
            : `/claims/${claimId}/show`
          return (
            <TicketListItem
              ticketDoc={ticketDoc}
              key={ticketDoc.id}
              link={link}
              claimId={claimId}
              showPhoneIcons
              colorItemsByStatus={false}
            />
          )
        })}
        {hasMore && (
          <Button
            fullWidth
            disabled={loadingMore}
            onClick={loadMore}
          >
            Show More
          </Button>
        )}
      </List>
    </Box>
  )
}
